const API_PROTOCOL = process.env.API_PROTOCOL || 'http';
const API_HOST = process.env.API_HOST || 'localhost';
const API_PORT = process.env.API_PORT || '8000';
const API_BASE_ENDPOINT = process.env.API_BASE_ENDPOINT || '/api';

export const API_CONFIG = {
    BASE_URL: `${API_PROTOCOL}://${API_HOST}:${API_PORT}${API_BASE_ENDPOINT}`,
    TIMEOUT: 30000,
    RETRY: {
        TYPE: "linear",
        ATTEMPTS: 3,
        DELAY: 1000
    }
} as const;

export const API_ENDPOINTS = {
    KYC: {
        INITIALIZE: '/kyc/verify',
        FINALIZE: '/kyc/finalize',
        CHECK_STATUS: '/kyc/check-status',
        SUMSUB_SDK_TOKEN: '/kyc/sdk-token',
    },
} as const;

